import { Switch, Route, Redirect } from 'react-router-dom';
import loadable from '@loadable/component';

import customer from 'containers/Contactless';

// COMPONENTS
const CustomerCheckIn = customer(loadable(() => import('views/CustomerCheckIn')));
const WelcomeScreen = customer(loadable(() => import('views/CustomerCheckIn/components/WelcomeScreen.component')));

const CustomerCheckInRoutes = () => {
  return (
    <Switch>
      <Route path="/fleet/public/customer-checkin/welcome" component={WelcomeScreen} exact />
      <Route path="/fleet/public/customer-checkin/:step" component={CustomerCheckIn} exact />
      <Route path="/fleet/public/customer-checkin">
        {(props) => {
          return (
            <Redirect
              to={{
                pathname: '/fleet/public/customer-checkin/welcome',
                search: props.location.search,
                state: props.location.state,
              }}
            />
          );
        }}
      </Route>
    </Switch>
  );
};

export default CustomerCheckInRoutes;
